export const CONTROL_LEVELS = [
    {
        level: 1,
        label: "ciq.level_one", // lang key
        color: "#0066FF"
    },
    {
        level: 2,
        label: "ciq.level_two", // lang key
        color: "#B83EE3"
    },
    {
        level: 3,
        label: "ciq.level_three", // lang key
        color: "#89C22C"
    }
]

export const CALC_TYPES = {
    LEAFLET_VALUE: "LEAFLET_VALUE",
    MANUAL_AVERAGE: "MANUAL_AVERAGE"
}

export const IMPRECISION_TYPES = {
    MANUAL: "MANUAL",
    BIOLOGICAL_VARIATION: "BIOLOGICAL_VARIATION"
}